import { Header, Icon } from "semantic-ui-react";

import React from "react";

import Flex from "../../../../../../components/Flex/Flex";
import truncateString from "../../../../../ui/utils/truncateString";
import { setDiscussion } from "../../../../state/discussion";

import DiscussionChannelDropdownMenu from "../../../DiscussionChannelDropdownMenu/DiscussionChannelDropdownMenu";

import DiscussionChannelParticipants from "./DiscussionChannelParticipiants";

export default function DiscussionChannelHeader({ channel }) {
	function capitalizeFirstLetter(name) {
		return String(name).charAt(0).toUpperCase() + String(name).slice(1);
	}

	return (
		<Flex style={{ padding: 15 }}>
			<Flex justifyContent="flex-start" gap={10}>
				<div>
					<Icon
						name="list ul"
						link
						disabled={channel === null}
						style={{ margin: 0 }}
						onClick={() => {
							setDiscussion({ isOpen: true, channelId: null });
						}}
					/>
				</div>

				<Header as="h4" style={{ margin: 0 }}>
					{capitalizeFirstLetter(channel.name)}
					<Header.Subheader>{truncateString(channel.subject.name, 20)}</Header.Subheader>
				</Header>

				<DiscussionChannelParticipants channel={channel} />
			</Flex>

			<DiscussionChannelDropdownMenu channel={channel} />
		</Flex>
	);
}
